var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconKeyValue = function SvgMiconKeyValue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M29 13h-1.75L25 22.03 22.79 13H21l2.5 10h3zM9.78 23H12l-3.78-6L12 13H9.76L6 17.17V9H4v14h2v-3.75l.96-1.04zM16.254 23.227c.874 0 1.254-.494 1.254-1.178v-.285c0-.684-.38-1.178-1.254-1.178S15 21.08 15 21.764v.285c0 .684.38 1.178 1.254 1.178M17.508 14.393c0 .684-.38 1.178-1.254 1.178S15 15.077 15 14.393v-.285c0-.684.38-1.178 1.254-1.178s1.254.494 1.254 1.178z"
  })));
};
export default SvgMiconKeyValue;